export const PLAIN_TEXT_CLIPBOARD_MIMETYPE = 'text/plain';
export const HTML_CLIPBOARD_MIMETYPE = 'text/html';

export const copyToClipboard = async (text: string): Promise<void> => {
  await window.PMW.copyToClipboard(text);
};

export const copyTextAndImageToClipboard = async (text: string, imageBlob: Blob): Promise<void> => {
  if (typeof ClipboardItem === 'undefined' || navigator.clipboard?.write === undefined) {
    await copyToClipboard(text);
    return;
  }
  try {
    await navigator.clipboard.write([
      new ClipboardItem({
        [PLAIN_TEXT_CLIPBOARD_MIMETYPE]: new Blob([text], {type: PLAIN_TEXT_CLIPBOARD_MIMETYPE}),
        [imageBlob.type]: imageBlob,
      }),
    ]);
  } catch {
    await copyToClipboard(text);
  }
};

export const readFromClipboard = async (): Promise<string> => {
  return window.PMW.readFromClipboard();
};

export const isClipboardAPISupported = (): boolean => {
  return navigator.clipboard !== undefined;
};

export const extractImageFilesFromClipboard = (items: DataTransferItemList | undefined): File[] => {
  if (!items) {
    return [];
  }
  const imageFiles: File[] = [];
  for (const item of items) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile();
      if (file) {
        imageFiles.push(file);
      }
    }
  }
  return imageFiles;
};
